import { render } from "./OrderDetail.vue?vue&type=template&id=ddc59900&scoped=true"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"

import "./OrderDetail.vue?vue&type=style&index=0&id=ddc59900&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\weapon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddc59900"]])

export default __exports__